import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const WindCompanyNominationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to nominations list with selected nomination to open the Dossier modal
    navigate(`/oem-company/nominations?selected=${id}`, { replace: true });
  }, [id, navigate]);

  return null;
};

export default WindCompanyNominationDetail;
